var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowersteering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0031 2.42582e-07C16.0468 -0.000615809 12.1792 1.17215 8.88957 3.36996C5.59991 5.56776 3.03598 8.69186 1.52212 12.3471C0.00825521 16.0022 -0.387527 20.0243 0.384836 23.9045C1.1572 27.7846 3.06301 31.3486 5.86118 34.1454C8.65935 36.9423 12.2242 38.8464 16.1047 39.617C19.9852 40.3875 24.0071 39.9899 27.6616 38.4743C31.3161 36.9587 34.439 34.3933 36.6352 31.1026C38.8315 27.812 40.0025 23.9438 40 19.9875C39.9967 14.6859 37.8885 9.60249 34.1388 5.85455C30.3891 2.10661 25.3047 0.000825783 20.0031 2.42582e-07ZM27.5179 21.9987C27.5179 26.7134 24.5494 29.632 20.0967 29.632C15.5285 29.632 12.4758 26.7134 12.4758 21.9987V15.2697L17.4649 13.9414V21.9987C17.4649 24.0567 18.5189 25.2074 20.0967 25.2074C21.5591 25.2074 22.5382 24.0567 22.5382 21.9987V12.585L27.5273 11.2535L27.5179 21.9987Z",
    fill: "#2574DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowersteering);
export default __webpack_public_path__ + "static/media/Powersteering.61deb873b1767a1054332ee2e2d7646f.svg";
export { ForwardRef as ReactComponent };